import { useState } from 'react';
import PropTypes from 'prop-types';
import { IconButton, Tooltip } from '@material-ui/core';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import CompanyAdminsModal from './CompanyAdminsModal';

CompanyAdminsButton.propTypes = {
  company: PropTypes.object.isRequired
};

export default function CompanyAdminsButton({ company }) {
  const [modalOpen, setModalOpen] = useState(false);

  const handleOpen = (event) => {
    event.stopPropagation();
    setModalOpen(true);
  };

  const handleClose = () => {
    setModalOpen(false);
  };

  return (
    <>
      <CompanyAdminsModal
        isOpen={modalOpen}
        closeHandler={handleClose}
        companyId={company.id}
        companyName={company.name}
      />
      <Tooltip title={`Admins for ${company.name}`}>
        <IconButton onClick={handleOpen} color="primary">
          <ManageAccountsOutlinedIcon data-testid="company-admins-icon" />
        </IconButton>
      </Tooltip>
    </>
  );
}
